import React from 'react';

class ActivityLogRowTextErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }; // update state to show fallback UI
  }

  componentDidCatch(error, info) {
    console.error('Error rendering child component:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div>Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ActivityLogRowTextErrorBoundary;
